const { onlyAlphaNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyAlphaNumeric(zipCode);

exports.countryDefinition = {
  country: 'Honduras',
  code: 'HN',
  schema: {
    company: { label: 'Company' },
    city: { label: 'Town', width: 0.5 },
    address: { label: 'Department' },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [['company'], ['zipCode', SPACE, 'city', SPACE, 'address']],
  formFormat: [['company'], ['zipCode', 'city'], ['address']],
  requiredFormFields: [
    { field: 'city' },
    { field: 'address' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[A-Za-z]{2}[0-9]{4}$/),
      error: 'Must be 6 characters, 2 letters and 4 numbers like CM1102'
    }
  ]
};
